import React, { useEffect } from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "../ui/sidebar";

interface CustomSideBarProps {
  logo: React.ReactNode;
  tabs: {
    tabId: string;
    text: string;
    href: string;
    icon: React.ReactNode;
    alertTab?: boolean;
  }[];
  currentActiveTabId: string;
  tabOnClickHandler: (tab: { tabId: string; text: string }) => void;
  footer: React.ReactNode;
}

export default function CustomSideBar({
  logo,
  tabs,
  tabOnClickHandler,
  currentActiveTabId,
  footer,
}: CustomSideBarProps) {
  useEffect(() => {
    console.log(currentActiveTabId);
  }, [currentActiveTabId]);

  return (
    <Sidebar
      collapsible="icon"
      className="logo border-r border-b border-[#EEE] bg-white min-h-screen max-h-screen"
    >
      <SidebarHeader className="px-12 font-openSans">{logo}</SidebarHeader>
      <SidebarContent className="px-12 mt-10">
        <div className="flex flex-col gap-7 font-openSans">
          {tabs.map((tab) => (
            <div
              key={tab.tabId}
              className={`flex items-center text-sm gap-4 cursor-pointer ${
                currentActiveTabId === tab.tabId
                  ? "text-brand-textBlack font-semibold"
                  : tab?.alertTab
                  ? "text-brand-orange font-semibold"
                  : "text-brand-textGrey hover:text-brand-textBlack"
              }`}
              onClick={() => tabOnClickHandler(tab)}
            >
              {tab.icon}
              <span>{tab.text}</span>
            </div>
          ))}
        </div>
      </SidebarContent>
      <SidebarFooter className="px-8 font-openSans lg:mb-6">
        {footer}
      </SidebarFooter>
      {/* <SidebarRail /> */}
    </Sidebar>
  );
}
